import { Box, IconButton, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { convertCamelCaseToDisplayText } from "../../utils";
import SiTextField from "../../core/si-textfield";
import moment from "moment";
function getNestedColumnValues(data, key) {
  if (!data || !Array.isArray(data.listData)) return [];
  return data.listData.map((plant, index) => (
    <div
      key={`${key}-${index}`}
      style={{ width: "max-content", marginBottom: "0.5rem" }}
    >
      {plant[key]?.length > 30 ? (
        <Tooltip title={plant[key]}>{plant[key]?.slice(0, 10)} ...</Tooltip>
      ) : (
        plant[key] || "-"
      )}
    </div>
  ));
}
export const HeaderConfig = [
  {
    label: "OEM",
    id: "oem",
    render: (data) => {
      return data?.oem?.name;
    },
  },
  {
    label: "Engine Model",
    id: "engineModel",
  },
  {
    label: "Engine Details",
    id: "listData",
    columns: [
      {
        label: "List Number",
        id: "listNumber",
        render: (data) => <>{getNestedColumnValues(data, "listNumber")}</>,
      },
      {
        label: "WSM Readiness",
        id: "wsmRediness",
        render: (data) => <>{getNestedColumnValues(data, "wsmRediness")}</>,
      },
      {
        label: "WSM Readiness Date",
        id: "wsmRedinessDate",
        render: (data) => (
          <>
            {data.listData?.map((plant, index) => (
              <div
                key={`wsmRedinessDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.wsmRedinessDate
                  ? moment(plant.wsmRedinessDate).format("DD/MM/YYYY")
                  : "-"}
              </div>
            ))}
          </>
        ),
      },
      {
        label: "Parts Catalogue Readiness",
        id: "partsCatalogueRediness",
        render: (data) => (
          <>{getNestedColumnValues(data, "partsCatalogueRediness")}</>
        ),
      },
      {
        label: "Parts Catalogue Rediness Date",
        id: "partsCatalogueRedinessDate",
        render: (data) => (
          <>
            {data.listData?.map((plant, index) => (
              <div
                key={`partsCatalogueRedinessDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.partsCatalogueRedinessDate
                  ? moment(plant.partsCatalogueRedinessDate).format(
                      "DD/MM/YYYY"
                    )
                  : "-"}
              </div>
            ))}
          </>
        ),
      },
      {
        label: "Recommended Parts List Readiness",
        id: "recommendedPartsListRediness",
        render: (data) => (
          <>{getNestedColumnValues(data, "recommendedPartsListRediness")}</>
        ),
      },
      {
        label: "Remarks",
        id: "remarks",
        render: (data) => <>{getNestedColumnValues(data, "remarks")}</>,
      },
      {
        label: "Alpha Stage Date",
        id: "alphaStageDate",
        render: (data) => (
          <>
            {data.listData?.map((plant, index) => (
              <div
                key={`alphaStageDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.alphaStageDate
                  ? moment(plant.alphaStageDate).format("DD/MM/YYYY")
                  : "-"}
              </div>
            ))}
          </>
        ),
      },
      {
        label: "Beta Stage Date",
        id: "betaStageDate",
        render: (data) => (
          <>
            {data.listData?.map((plant, index) => (
              <div
                key={`betaStageDate-${index}`}
                style={{ width: "max-content", marginBottom: "0.5rem" }}
              >
                {plant.betaStageDate
                  ? moment(plant.betaStageDate).format("DD/MM/YYYY")
                  : "-"}
              </div>
            ))}
          </>
        ),
      },
    ],
  },
  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)} sx={{ p: 0 }}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)} sx={{ p: 0 }}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];

export const headerslist = [
  { id: "listNumber", label: "List Number" },
  {
    id: "alphaStageDate",
    label: "Alpha Stage Date",
    render: () => {
      <SiTextField />;
    },
  },
  { id: "betaStageDate", label: "Beta Stage Date" },
  { id: "wsmRediness", label: "WSM Readiness" },
  { id: "partsCatalogueRediness", label: "Parts Catalogue Readiness" },
  { id: "recommendedPartsListRediness", label: "Recommended Parts List" },
  { id: "remarks", label: "Remarks" },
];
export const getProductFormConfig = (oemsList) => [
  {
    name: "oem",
    type: "autocomplete",
    label: "OEM Org",
    options: oemsList,
    placeholder: "Oem",
    required: true,
  },
  {
    name: "engineModel",
    type: "text",
    label: "Engine Model",
    placeholder: "Engine Model",
    required: true,
  },
];
